import React, { useState, useEffect, useCallback } from 'react';

import { useSpdCore } from '../../../common/hooks/useSpdCore';
import { Selector, Option } from '../Selects/Selector';

export interface CompanyByNameOrNipSelectorProps {
  readOnly?: boolean;
  value?: string | null;
  placeholder?: string;
  className?: string;
  clearable?: boolean;
  onChange?: (option: Option) => void;
  refreshKey?: number;
}

export default (props: CompanyByNameOrNipSelectorProps) => {
  const spd = useSpdCore();
  const [displayName, setDisplayName] = useState<string>('');

  useEffect(() => {
    let mounted = true;
    if (props.value) {
      spd.companies
        .get(props.value || '')
        .then(company => {
          if (mounted) {
            if (company) {
              setDisplayName(
                company.name +
                  (company.nip ? ' (NIP: ' + company.nip + ')' : ''),
              );
            } else {
              setDisplayName('');
            }
          }
        })
        .catch(error => {
          console.error('błąd ładowania firmy: ', error);
        });
    } else {
      setDisplayName('');
    }
    return () => {
      mounted = false;
    };
  }, [props.value, props.refreshKey, spd.companies]);

  const provider = useCallback(
    (text: string) => {
      return spd.companies.getOptionsByNameOrNip(text);
    },
    [spd.companies],
  );

  return (
    <Selector
      uniqueKey={'companies-' + displayName + JSON.stringify(props.value)}
      className={props.className}
      readOnly={props.readOnly}
      creatable={false}
      placeholder={props.placeholder || 'Wskaż...'}
      provider={provider}
      value={displayName}
      onChange={props.onChange}
      clearable={props.clearable}
    />
  );
};
